
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4.238 23.667l8.095 8.095M8.286 27.714L26.095 9.905M22.048 5.857l8.095 8.095M12.333 31.762L1 35l3.238-11.333L26.193 1.71a2.429 2.429 0 013.435 0l4.66 4.66a2.429 2.429 0 010 3.436L12.334 31.762z"}})])])
          )
        }
      }
    